import iosBridge from '../store/ios_bridge'
import axios from 'axios';

var media_utility = {
  axiosSource:{},
  /**
   * checkFileExtension
   *
   */
  checkFileExtension(filename) { 
    var extension = filename.substring(filename.lastIndexOf('.') + 1); 
    return extension; 
  },  
  /**
   * bytesToSize
   */
    bytesToSize(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes == 0) return '0 Byte';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    },
    /*
    * getFileType
    *
    */
    getFileType(filetype) {
      if(filetype.match('image.*'))
        return 'image';

      if(filetype.match('video.*'))
        return 'video';

      if(filetype.match('audio.*'))
        return 'audio';

      return 'file';
    },
    /**
     * file_download
     */
    file_download(content_message_data){
      this.axiosSource = axios.CancelToken.source();
      return new Promise((resolve) => {
        axios({
          method: 'get',
          url: content_message_data.url,
          responseType: 'arraybuffer',
          cancelToken: this.axiosSource.token
        })
        .then(response => {
          this.forceFileDownload(response, content_message_data)
          resolve({
            response:response
          })
        })
        .catch(() => {
          console.log('error occured in file_download')
        });
      });
    },
    /**
     * cancel_download
     */
    cancel_download(){
      this.axiosSource.cancel();
    },
    /*
    * forceFileDownload
    *
    */
    async forceFileDownload(response, media){
      let url = media.url;
      const type = response.headers['content-type'];
      let subfolder = this.get_file_mime_type(type);

      if(window.webkit){
        iosBridge.sendMessage({"module":"saveFileToDeviceFolder", "data":{"url":media.url, "subfolder":subfolder, "openaftersave":"false"}});
        return;  
      }
      else if(window.androidBridge){          
        window.androidBridge.saveFileToDeviceFolder(media.url, subfolder);
        return;
      }
      else{
        const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })
        url = window.URL.createObjectURL(blob);
      }
      
      const link = document.createElement('a')
      link.href = url;
      link.setAttribute('download', media.file_name) //or any other extension
      document.body.appendChild(link)
      link.click();
    },
    /**
     * compress
     * 
     */
    compress(imageSrc, fileName) {
      var keepAspectRatio = true;
      var compressPercentage = ( 100 - process.env.VUE_APP_FILE_COMPRESS_PERCENTAGE );
      return new Promise((resolve, reject) => {
        let img = new Image()
        img.src = imageSrc;

        img.onload =  () => {
          const elem = document.createElement('canvas');
          let width = (img.width * compressPercentage)/100;
          let height = (img.height * compressPercentage)/100;
          
          if(keepAspectRatio){
            const scaleFactor = width / img.width;
            height = img.height * scaleFactor;
          }
          
          elem.width = width;
          elem.height = height;
          const ctx = elem.getContext('2d');
          
          // img.width and img.height will contain the original dimensions
          ctx.drawImage(img, 0, 0, width, height);
          ctx.canvas.toBlob((blob) => {
            const file = new File([blob], fileName, {
              type: 'image/jpeg',
              lastModified: Date.now()
            });
            
            resolve({
              file:file,
              url:URL.createObjectURL(file)
            });                    
          }, 'image/jpeg', 1);
        };
        
        img.onerror = reject;
      })
    },  
    /*
     * fileAutoDownload
     * Auto Download only if IOS or Android Device
     */
   async fileAutoDownload(media){
    if(window.webkit || window.androidBridge){
      let response = {};
      response.headers = {};
      response.headers['content-type'] = media.file_mime_type;
      media.url = this.get_firebase_gcp_url_format(media);
      this.forceFileDownload(response, media);
    }
  },
  /*
   * getDownloadedFileBase64
   *
   */
  async getDownloadedFileBase64(file_name, file_type, file_mime_type, formatResponse=true){
    let subfolder = this.get_file_mime_type(file_mime_type);
    let base64image = '';
    if(window.webkit){
      if(file_type == 'image'){
        base64image = await iosBridge.sendMessage({"module":"getBase64Image", "data":{"image_name":file_name, "subfolder":subfolder}});
      }
      else{
        base64image = await iosBridge.sendMessage({"module":"checkFileExists", "data":{"image_name":file_name, "subfolder":subfolder}});        
      }
      base64image = base64image.data;
    }
    else if(window.androidBridge){
      if(file_type == 'image'){
        base64image = await window.androidBridge.getBase64Image(file_name, subfolder);
      }
      else{        
        base64image = await window.androidBridge.checkFileExists(file_name, subfolder);
      }
    }
    
    if(!base64image || base64image == undefined || base64image == "false"){
      base64image = null;
    }
    else{
      //To display the image on chat message, requires formatting, where as when received from ext. app does not.
      if(formatResponse){
        base64image = 'data:' + file_mime_type + ';base64,'+ base64image;
      }      
    }

    return base64image;
  },
  /**
   * get_firebase_gcp_url_format
   */
  get_firebase_gcp_url_format(media, module_id = false, board_id = false, calendar = false){
    let time_stamp = +new Date()+media.id;
    let firebase_gcp_url = process.env.VUE_APP_FIREBASE_FILE_URL;
    
    if(module_id) {
      firebase_gcp_url += process.env.VUE_APP_FIREBASE_STORAGE_BOARD_CONTENT_FOLDER+'%2F';
      return firebase_gcp_url+board_id+'%2F'+module_id+'%2F'+media.file_name+'?generation='+time_stamp+'&alt=media';
    }
    else if(calendar) {
      firebase_gcp_url += process.env.VUE_APP_FIREBASE_STORAGE_CALENDAR_CONTENT_FOLDER+'%2F';
      return firebase_gcp_url+media.user_id+'%2F'+media.id+'?generation='+time_stamp+'&alt=media';
    }
    else {
      firebase_gcp_url += process.env.VUE_APP_FIREBASE_STORAGE_MEDIA_CONTENT_FOLDER+'%2F';
      return firebase_gcp_url+media.user_id+'%2F'+media.file_name+'?generation='+time_stamp+'&alt=media';
    }
  },
  /**
   * get_file_mime_type
   */
  get_file_mime_type(type){
    let subfolder = "Mesh Documents";
    if(type.toLowerCase().indexOf('image'.toLowerCase()) !== -1){
      subfolder = "Mesh Images";
    }
    else if(type.toLowerCase().indexOf('video'.toLowerCase()) !== -1){
      subfolder = "Mesh Videos";
    }
    else if(type.toLowerCase().indexOf('audio'.toLowerCase()) !== -1){
      subfolder = "Mesh Audios";
    }
    else {
      subfolder = "Mesh Documents";
    }
    return subfolder;
  },
  /**
   * displayLocalFile
   */
  async displayLocalFile(media){
    if (process.env.VUE_APP_DEBUG == "true") {console.log("displayLocalFile",media);}    
    if(!media || !media.file_name){
      return null;
    }

    let subfolder = this.get_file_mime_type(media.file_mime_type);
    let result = "true";
    if(window.webkit){
      if(media.file_ext == "ics"){
        result = "false";
      }
      else{
        result = await iosBridge.sendMessage({"module":"displayLocalFile", "data":{"filename":media.file_name, "subfolder":subfolder}});
      }
      
      if(result == "false"){
        await iosBridge.sendMessage({"module":"launchInBrowser", "data":{"url":media.url}});
      }
    }
    else if(window.androidBridge){
      result = window.androidBridge.displayLocalFile(media.file_name, subfolder);
      if(!result){
        if (process.env.VUE_APP_DEBUG == "true") {console.log("window.open");}    
        window.open(media.url, '_blank');
      }
    }
    else{
      window.open(media.url, '_blank'); //for only browset
    }
  },
  /**
   * getFileTypeInUrl
   */
  getFileTypeInUrl(url){
    let file_obj = {
      file_type:'file',
      file_name:''
    }
    let last_segment_array = [];
    let last_segment = url.substring(url.lastIndexOf('/')+1);
    if(last_segment){
      last_segment_array = last_segment.split('?');
      if(last_segment_array && last_segment_array.length > 0){
        file_obj.file_name = last_segment_array[0].split('%2F')[2];
      }
    }
    //for check image type
    if(/\.(jpeg|jpg|gif|png|tiff|tif|webp|bmp|apng|ico|cur|jfif|pjpeg|pjp|svg)/g.test(url)){
      file_obj.file_type = "image";
      return file_obj;
    }
    //for check vedio type
    if(/\.(mp4|mpg|mpeg|avi|wmv|mov|rm|ram|swf|flv|ogg|webm)/g.test(url)){
      file_obj.file_type = "video";
      return file_obj;
    }
    return file_obj;
  },
  /**
   * listingMediaMessageFormat
   */
  listingMediaMessageFormat(msg, msg_obj = null){
    let message_array = msg.split(' ');
    let url = message_array[0];
    message_array.shift();
    let caption = message_array.join(' ').trim();
    let icon = document.createElement('v-icon');
    let file_obj = {};
    
    if(msg_obj && msg_obj.message_content_data){
      file_obj = msg_obj.message_content_data;
    }
    else{
      file_obj = this.getFileTypeInUrl(url);
    }
    
    if(file_obj.file_type == 'image'){
      icon.innerHTML = " Photo"
      icon.className = "mdi mdi-camera";
    }
    else if(file_obj.file_type == 'file'){
      icon.innerHTML = " File";
      icon.className = "mdi mdi-file";
    }
    if(caption){
      icon.innerHTML += ' '+ caption;
    }
    else{
      icon.innerHTML += ' '+ file_obj.file_name;
    }
    return icon;
  },
  /**
   * getBase64ImageThumbnail
   * 
   */
  getBase64ImageThumbnail(url){ 
    var resize_width = process.env.VUE_APP_GROUP_USER_ICON_SIZE;
    return new Promise((resolve) => {
      let img = new Image()
      img.src = url;
      img.crossOrigin = 'anonymous';
      img.onload =  (el) => {
        const elem = document.createElement('canvas');
        const ctx = elem.getContext('2d');
        //scale the image to 100 (width) and keep aspect ratio
        var scaleFactor = resize_width / el.target.width;
        elem.width = resize_width;
        elem.height = el.target.height * scaleFactor;
        ctx.drawImage(el.target, 0, 0, elem.width, elem.height);
        let base64 = elem.toDataURL('image/png');
        resolve(base64);
      };
      
      img.onerror = ()=>{
        resolve('');
      }
    })
  },
  /*
    * checkStrFirstCharHasAlphabet
    * */
   checkStrFirstCharHasAlphabet(str){
    if(/^[A-Za-z]/.test(str)) {
      return true;
    }
    return false;
  },
  /*
    * get_user_icon
    * */
   get_user_icon(user, user_contact_list_lf){
    var user_icon = '';
    
    if(user_contact_list_lf 
    && user_contact_list_lf[user.user_id] 
    && user_contact_list_lf[user.user_id].user_image_base64)
    {
      user_icon = user_contact_list_lf[user.user_id].user_image_base64;
    }
    else if(user.image){
      user_icon = user.image;
    }
    else if(user.user_name && this.checkStrFirstCharHasAlphabet(user.user_name)){
      user_icon = null; //require(`../assets/avatar/${user.user_name.charAt(0).toUpperCase()}.png`);
    }
    else{
      user_icon = require(`../assets/img/gallery1xxxhdpi.png`);      
    }
    
    return user_icon;
  },
  /*
  * get_group_icon
  * */
  get_group_icon(group, group_icon_data){
    var group_icon = '';
    if(group_icon_data && group_icon_data[group.group_id] && group_icon_data[group.group_id].group_icon_base64){
      group_icon = group_icon_data[group.group_id].group_icon_base64;
    }
    else if(group.group_icon){
      group_icon = group.group_icon;
    }
    else if(group.group_name && this.checkStrFirstCharHasAlphabet(group.group_name)){
      group_icon = null; //require(`../assets/avatar/${group.group_name.charAt(0).toUpperCase()}.png`);      
    }
    else{
      group_icon = require(`../assets/img/gallery1xxxhdpi.png`);
    }
    
    return group_icon;
  },
  /*
   * externalContentBuilder(sharedContentObj)
   * sharedContentObj.shared_content_data_type = "text", "file", "fileArr"
   * sharedContentObj.shared_content_data = base64 encoded data. This needs to be decoded. 
   *  - It contains text or the Content URI for the shared file/file Arr
   *  
   * For Testing on Browser
   * http://localhost:4444/share_content?shared_content_data=dGVzdDEucG5n&shared_content_data_type=file
   * http://localhost:4444/share_content?shared_content_data=dGVzdDIuanBn&shared_content_data_type=file
   * http://localhost:4444/share_content?shared_content_data=dGVzdDMucGRm&shared_content_data_type=file
   * http://localhost:4444/share_content?shared_content_data=SGVsbG8gV29ybGQ=&shared_content_data_type=text
   * 
   * Multiple Items
   * http://localhost:4444/share_content?shared_content_data=W3siZmlsZW5hbWUiOiIyMDE5MTAyN18wMDU0MjguanBnIiwibWltZXR5cGUiOiJpbWFnZVwvanBlZyJ9LHsiZmlsZW5hbWUiOiIyMDE5MTAyN18wMDUzNDMuanBnIiwibWltZXR5cGUiOiJpbWFnZVwvanBlZyJ9LHsiZmlsZW5hbWUiOiIyMDE5MTAyN18wMDE5MjEuanBnIiwibWltZXR5cGUiOiJpbWFnZVwvanBlZyJ9XQ==&shared_content_data_type=file
   * 
   */
  async externalContentBuilder(self, sharedContentObj) {        
    let shared_content_data_type = sharedContentObj['shared_content_data_type'];

    let msg = null;
    let file = null;
    let content_data = null;

    if (shared_content_data_type == "file") {
      let fileArr = await JSON.parse(await atob(sharedContentObj['shared_content_data']));

      let sharedContentResponseArr = [];
      for(const fileObj of fileArr){
        console.log("file:", file);
        let filename = fileObj['filename'];
        let mimetype = fileObj['mimetype'];

        let file_type = await media_utility.getFileType(mimetype);
    
        //Formatted response does not work for base64toBlob()
        let formatResponse=false;
        content_data = await media_utility.getDownloadedFileBase64(filename, file_type, mimetype, formatResponse);

        msg = filename;

        //Convert base64 data to a blob
        let blob = await media_utility.base64toBlob(content_data, mimetype);
  
        //Convert blob data to a file
        let fd = new FormData();
        fd.append("file", blob, filename);
  
        for (let value of fd.values()) {        
          file = value;
          let attachmentRespObj = await media_utility.file_size_validation(self, file);
          if (attachmentRespObj == false) {
            continue;
          }
  
          file = attachmentRespObj;
        }

        sharedContentResponseArr.push({ "msg": msg, "file": file, "file_name": filename, "file_ext": file_type });
      }

      return sharedContentResponseArr;
    }
    else{      
      //Text or URL
      sharedContentObj['shared_content_data'] = sharedContentObj['shared_content_data'].replace(" ", "+");//Replace space with "+" sign

      msg = await decodeURIComponent(await atob(sharedContentObj['shared_content_data']));
      return [{ "msg": msg, "file": null, "file_name": null, "file_ext": null }];
    }
  },
  /*
   * base64toBlob(b64Data, contentType, sliceSize)
   *  
   */
  async base64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = await atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = await new Blob(byteArrays, { type: contentType });
    return blob;
  },
  /**
  * bytesToSizeInBytes
  * 
  */
  bytesToSizeInBytes(bytes) {
    return Math.round(bytes / Math.pow(1024, 2), 2);
  },
  /**
   * file_size_validation
   */
  async file_size_validation(self, attachment) {
    if (attachment) {
      let fileType = media_utility.getFileType(attachment.type);

      if (fileType == 'video' || fileType == 'audio') {
        self.err_msg = 'Video and Audio not allowed currently.';
        self.alert_color = 'error';
        return false;
      }

      let fileSize = await media_utility.bytesToSizeInBytes(attachment.size);
      if (fileType == 'file') {
        //File size limit
        if (fileSize > process.env.VUE_APP_FILE_FILE_SIZE_LIMIT) {
          self.err_msg = attachment.name + ' file size should be less then ' + process.env.VUE_APP_FILE_FILE_SIZE_LIMIT + 'MB';
          self.alert_color = 'error';
          return false;
        }
      }

      if (fileType == 'image') {
        //Image size limit
        if (fileSize > process.env.VUE_APP_FILE_IMAGE_SIZE_LIMIT) {
          self.err_msg = attachment.name + ' image size should be less then ' + process.env.VUE_APP_FILE_IMAGE_SIZE_LIMIT + 'MB';
          self.alert_color = 'error';
          return false;
        }

        //Image compress if image is large then 2 MB
        if (fileSize > 1) {          
          var url = URL.createObjectURL(attachment);        
          let compressed_file = await media_utility.compress(url, attachment.name);
          if(compressed_file.size < attachment.size){
            url = compressed_file.url;
            attachment = compressed_file.file;            
          }
        }
      }

      return attachment;
    }
    return false;
  },  

};

export default media_utility;